/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import ThankYou from '../../components/Account/SignUp/ThankYou';
import { ROUTES } from '../../assets/constants/strings';
import Resent from '../../components/Account/SignUp/Resent';
import ApiSignUpForm from '../../components/API/SignUp';
import ApiPagesWrapper from '../../components/API/SignUp/PageWrapper';

const mapStateToProps = (state) => ({
  user: state.user.user,
  plans: state.user.plans,
});

const ApiSignUp = () => {
  const [step, setStep] = useState(1);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 950);

  // using refs to ensure the load logic works
  const screenRef = useRef(isSmallScreen);
  screenRef.current = isSmallScreen;

  useEffect(() => {
    // listen for changes in window width for hide/show logic
    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  const checkScreenSize = () => {
    screenRef.current = window.innerWidth < 950;
    setIsSmallScreen(screenRef.current);
  };

  // step 1 - after form is filled and user is +properly validated, display thank you component
  // step 2 - user clicked on email link redirect user to login page

  return (
    <ApiPagesWrapper
      showLink={true}
      handleLink={`${ROUTES.LOGIN}?portal=api`}
      isSmallScreen={isSmallScreen}
      isRegister={step === 1}
      signupForm={
        <ApiSignUpForm
          handleUserJoined={() => setStep(2)}
          isSmallScreen={isSmallScreen}
        />
      }
    >
      {step === 1 ? (
        isSmallScreen && (
          <ApiSignUpForm
            handleUserJoined={() => setStep(2)}
            isSmallScreen={isSmallScreen}
          />
        )
      ) : step === 2 ? (
        <ThankYou resendUserEmail={() => setStep(3)} isApi />
      ) : (
        <Resent />
      )}
    </ApiPagesWrapper>
  );
};

export default connect(mapStateToProps, null)(ApiSignUp);
